import { render, staticRenderFns } from "./consultationRecord.vue?vue&type=template&id=457a4182&scoped=true"
import script from "./consultationRecord.vue?vue&type=script&lang=js"
export * from "./consultationRecord.vue?vue&type=script&lang=js"
import style0 from "./consultationRecord.vue?vue&type=style&index=0&id=457a4182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457a4182",
  null
  
)

export default component.exports